// One empty state for every Fashion work screen: a small line icon, a one-line
// title, a one-line hint, and an optional next step. `as="li"` when it stands
// in for the rows of a list.
import React from "react";
import "./FashionWorkPanels.css";

const ICONS = {
  // A tag: nothing in this list yet.
  empty: (
    <>
      <path d="M3 12V4a1 1 0 0 1 1-1h8l9 9-9 9z" />
      <circle cx="8" cy="8" r="1.5" />
    </>
  ),
  search: (
    <>
      <circle cx="11" cy="11" r="6" />
      <path d="m20 20-4.5-4.5" />
    </>
  ),
  offline: (
    <>
      <path d="M2 8.5a15 15 0 0 1 20 0M5.5 12a10 10 0 0 1 13 0M9 15.5a5 5 0 0 1 6 0" />
      <path d="M3 3l18 18" />
    </>
  ),
  error: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v6M12 16.5v.5" />
    </>
  ),
  // A pointer: pick something on the left.
  pick: (
    <>
      <path d="M5 3l14 7-6 2-2 6z" />
    </>
  ),
};

export default function EmptyState({ as: Tag = "div", icon = "empty", title, hint, action, role, compact = false, className = "" }) {
  const glyph = icon ? ICONS[icon] : null;
  return (
    <Tag className={`fp-es${compact ? " is-compact" : ""}${className ? ` ${className}` : ""}`} role={role}>
      {glyph && (
        <span className="fp-es-ic" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
            {glyph}
          </svg>
        </span>
      )}
      {title && <b className="fp-es-t">{title}</b>}
      {hint && <span className="fp-es-h">{hint}</span>}
      {action && (
        <button type="button" className="fp-btn-ghost fp-btn-sm fp-es-a" onClick={action.onClick}>
          {action.label}
        </button>
      )}
    </Tag>
  );
}
